import * as types from "./mutation-types";
import User from "../api/user";

export default {
  aliPay({ commit }, data) {
    // 支付时调用
    return new Promise((resolve) => {
      User.aliPay(data).then((res) => {
        if (res.data.code === 500) {
          commit(types.SET_SNACK_INFO, {
            status: true,
            color: "error",
            msg: "Server error, please try again later",
            timeout: 5000,
          });
        }
        resolve(res);
      });
    });
  },
  aliQueryAnswer({ commit }, data) {
    //支付结果查询
    return new Promise((resolve) => {
      User.aliQuery(data).then((res) => {
        if (res.data.code === 500) {
          commit(types.SET_SNACK_INFO, {
            status: true,
            color: "error",
            msg: "Server error, please try again later",
            timeout: 20000,
          });
        } else {
          if (res.data.data === true) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "info",
              msg: "Order paid successfully",
              timeout: 20000,
            });
          }
        }

        resolve(res);
      });
    });
  },
  aliOrder({ commit }, data) {
    // 所有订单查询
    return new Promise((resolve) => {
      User.aliOrder(data).then((res) => {
        if (res.data.code === 500) {
          commit(types.SET_SNACK_INFO, {
            status: true,
            color: "error",
            msg: "Server error, please try again later",
            timeout: 5000,
          });
        }
        resolve(res);
      });
    });
  },
  aliInvoice({ commit }, data) {
    //开票接口
    return new Promise((resolve, reject) => {
      User.aliInvoice(data)
        .then((res) => {
          if (res.data.code === 200) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "info",
              msg: "Invoice application submitted",
              timeout: 6000,
            });
          } else {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Server error, please try again later",
              timeout: 6000,
            });
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getVerify() {
    // 获取验证码
    return new Promise((resolve) => {
      User.operateAuth("get").then((res) => {
        resolve(res);
      });
    });
  },
  checkVerify({ commit }, data) {
    // 检验验证码
    return new Promise((resolve) => {
      User.operateAuth("post", data).then((res) => {
        if (res.data.code === 200) {
          commit(types.SET_SNACK_INFO, {
            status: true,
            color: "info",
            msg: "Verification successful",
            timeout: 2000,
          });
        } else {
          commit(types.SET_SNACK_INFO, {
            status: true,
            color: "error",
            msg: "Verification error",
            timeout: 3000,
          });
        }
        resolve(res);
      });
    });
  },
  activeAccount() {
    return new Promise((resolve, reject) => {
      User.activeAccount()
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  reactiveAccount({ commit }, data) {
    return new Promise((resolve, reject) => {
      User.reactive(data)
        .then((res) => {
          if (res.data.code === 200) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "info",
              msg: "Mail sent, please check",
              timeout: 5000,
            });
          } else {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Server error, please try again later",
              timeout: 3000,
            });
          }
          resolve(res);
        })
        .catch((err) => {
          commit(types.SET_SNACK_INFO, {
            status: true,
            color: "error",
            msg: "Server error, please try again later",
            timeout: 3000,
          });
          reject(err);
        });
    });
  },
  resetPwd({ dispatch, commit }, data) {
    // 修改密码
    return new Promise((resolve) => {
      User.resetPwd(data)
        .then((res) => {
          if (res.data.code === 200) {
            dispatch("signOut");

            window.localStorage.setItem("isSignIn", JSON.stringify(false));
            window.localStorage.removeItem("accessToken");
            window.localStorage.removeItem("refreshToken");
            commit(types.SET_SIGN_IN, false);

            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "info",
              msg: "The modification was successful please log in again",
              timeout: 3000,
            });
            commit(types.SET_SHOW_SIGNIN, true);
          } else if (res.data.code === 603) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Original password error",
              timeout: 3000,
            });
          } else {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Modify failed and try again late",
              timeout: 3000,
            });
          }
          resolve(res);
        })
        .catch(() => {
          commit(types.SET_SNACK_INFO, {
            status: true,
            color: "error",
            msg: "Modify failed and try again late",
            timeout: 2000,
          });
        });
    });
  },

  refreshToken({ commit }, data) {
    return new Promise((resolve) => {
      User.refreshToken(data).then((res) => {
        resolve(res);
      });
    });
  },

  //注册
  signUp({ commit }, user) {
    // 注册
    return new Promise((resolve) => {
      User.signUp(user)
        .then((res) => {
          if (res.data.code === 200) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "info",
              msg:
                "successful registration please click on the activation link at your mailbox",
              timeout: 5000,
            });
          } else {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Account registered",
              timeout: 3000,
            });
          }
          resolve(res);
        })
        .catch(() => {});
    });
  },
  //登录
  signIn({ commit }, UserData) {
    return new Promise((resolve, reject) => {
      User.signIn(UserData)
        .then((res) => {
          if (res.data.code === 200) {
            window.localStorage.setItem("isSignIn", JSON.stringify(true));
            commit(types.SET_SIGN_IN, true);
            window.localStorage.setItem(
              "accessToken",
              JSON.stringify(res.data.data.accessToken)
            );
            window.localStorage.setItem(
              "refreshToken",
              JSON.stringify(res.data.data.refreshToken)
            );
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "info",
              msg: "Login Success",
              timeout: 2000,
            });
          } else if (res.data.code === 601) {
            // unActive
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Please activate and use",
              timeout: 2000,
            });
          } else if (res.data.code === 602) {
            // 密码不正确
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Account does not exist",
              timeout: 3000,
            });
          } else if (res.data.code === 603) {
            // 密码不正确
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Password error",
              timeout: 3000,
            });
          }
          resolve(res);
        })
        .catch(() => {
          window.localStorage.setItem("isSignIn", JSON.stringify(false));
          commit(types.SET_SIGN_IN, false);
          reject("账号密码不匹配");
        });
    });
  },
  // 注销
  signOut({ commit }) {
    window.localStorage.clear();
    commit(types.SET_SNACK_INFO, {
      status: true,
      color: "info",
      msg: "Log-out success",
      timeout: 2000,
    });
    commit(types.SET_SIGN_IN, false);
  },
  getUserInformation({ commit }) {
    return new Promise((resolve, reject) => {
      User.getUserInfo()
        .then((res) => {
          commit(types.SET_USER, res.data.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  changeUserInformation({ commit }, data) {
    return new Promise((resolve, reject) => {
      User.changeUserInfo(data)
        .then((res) => {
          if (res.data.code === 200) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "info",
              msg: "Successful modifications",
              timeout: 2000,
            });
          } else {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Modify failed and try again late",
              timeout: 3000,
            });
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  molSearch({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      User.molSearch(data)
        .then((res) => {
          if (res.data.code === 701) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "No search results",
              timeout: 4000,
            });
          } else if (res.data.code === 702) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Please optimize the search criteria",
              timeout: 4000,
            });
          } else if (res.data.code === 604) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "No search permission",
              timeout: 4000,
            });
          } else {
            // code === 200
            commit("SET_BRIEFS", res.data.data);
            commit("SET_LISTWHAT", "mole");
            window.localStorage.setItem("listwhat", state.listWhat);
          }
          resolve(res);
        })
        .catch((error) => {
          if (error.response.status === 403) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "No search permission",
              timeout: 4000,
            });
          }

          reject(error);
        });
    });
  },
  crystalSearch({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      User.crystalSearch(data)
        .then((res) => {
          if (res.data.code === 701) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "No search results",
              timeout: 4000,
            });
          } else if (res.data.code === 702) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Please optimize the search criteria",
              timeout: 4000,
            });
          } else if (res.data.code === 604) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "No search permission",
              timeout: 4000,
            });
          } else {
            // code === 200
            let data = res.data.data;
            commit("SET_BRIEFS", data);
            commit("SET_LISTWHAT", "crystal");
            window.localStorage.setItem("listwhat", state.listWhat);
          }

          resolve(res);
        })
        .catch((error) => {
          if (error.response.status === 403) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "No search permission",
              timeout: 4000,
            });
          }
          reject(error);
        });
    });
  },
  reactionSearch({ commit }, data) {
    return new Promise((resolve, reject) => {
      User.reactionSearch(data)
        .then((res) => {
          if (res.data.code === 701) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "No search results",
              timeout: 4000,
            });
          } else if (res.data.code === 702) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Please optimize the search criteria",
              timeout: 4000,
            });
          } else if (res.data.code === 604) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "No search permission",
              timeout: 4000,
            });
          } else {
            commit("SET_BRIEFS", res.data.data.reactionVoItems);
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getReactionDetail({ commit }, data) {
    return new Promise((resolve, reject) => {
      User.reactionSearch(data)
        .then((res) => {
          if (res.data.code === 701) {
            commit("SET_BRIEFS", []);
            commit(types.SET_DETAIL, {
              properties: [],
              details: [],
            });
          } else if (res.data.code === 604) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg:
                "Your experience has run out, please contact your administrator to turn it on",
              timeout: 4000,
            });
          } else {
            commit("SET_BRIEFS", res.data.data.reactionVoItems);
            commit(types.SET_DETAIL, res.data.data.compound);
          }

          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      if (state.listWhat === "mole") {
        User.molSearch(data)
          .then((res) => {
            if (res.data.code === 604) {
              commit(types.SET_SNACK_INFO, {
                status: true,
                color: "error",
                msg:
                  "Your experience has run out, please contact your administrator to turn it on",
                timeout: 4000,
              });
              resolve(res);
            } else if (res.data.code === 701) {
              commit(types.SET_SNACK_INFO, {
                status: true,
                color: "error",
                msg: "No search results",
                timeout: 2000,
              });
              resolve(res);
            }
            commit(types.SET_DETAIL, res.data.data.moleculeItemVos[0]);
            resolve(res.data.data.moleculeItemVos[0]);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        User.crystalSearch(data)
          .then((res) => {
            if (res.data.code === 604) {
              commit(types.SET_SNACK_INFO, {
                status: true,
                color: "error",
                msg:
                  "Your experience has run out, please contact your administrator to turn it on",
                timeout: 4000,
              });
              resolve(res);
            } else if (res.data.code === 701) {
              commit(types.SET_SNACK_INFO, {
                status: true,
                color: "error",
                msg: "No search results",
                timeout: 2000,
              });
              resolve(res);
            }
            commit(types.SET_DETAIL, res.data.data.crystalItemVos[0]);
            resolve(res.data.data.crystalItemVos[0]);
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  },
  forgetPassword({ commit }, data) {
    // 发送邮件
    return new Promise((resolve, reject) => {
      User.forgetPassword(data)
        .then((res) => {
          if (res.data.code === 200) {
          } else if (res.data.code === 602) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Account does not exist",
              timeout: 4000,
            });
          } else {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Server error, please try again later",
              timeout: 5000,
            });
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  findBackPassword({ commit }, data) {
    return new Promise((resolve) => {
      User.findBackPassword(data)
        .then((res) => {
          if (res.data.code === 200) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "info",
              msg: "successful recovery",
              timeout: 2000,
            });
          } else if (res.data.code === 605) {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg:
                "Please click on the latest email link or rediscover your password",
              timeout: 4000,
            });
          } else {
            commit(types.SET_SNACK_INFO, {
              status: true,
              color: "error",
              msg: "Recovery failed try again late",
              timeout: 2000,
            });
          }
          resolve(res);
        })
        .catch(() => {
          commit(types.SET_SNACK_INFO, {
            status: true,
            color: "error",
            msg:
              "Please click on the latest email link or rediscover your password",
            timeout: 4000,
          });
        });
    });
  },
  smilesToFormula({ commit }, data) {
    return new Promise((resolve, reject) => {
      User.smilesToFormula(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  reactionToFormula({ commit }, data) {
    return new Promise((resolve, reject) => {
      User.reactionToFormula(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  smilesToSvg({ commit }, data) {
    return new Promise((resolve, reject) => {
      User.smilesToSvg(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  download({ commit }) {
    return new Promise((resolve, reject) => {
      User.download()
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
